var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDahboardComingSoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 548,
    height: 344,
    viewBox: "0 0 548 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.488 94.2294L526.251 89.8774",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M501.334 64.1919L496.299 78.1866",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M506.197 83.9894L522.837 65.728",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M315.562 293.909L296.874 283.157V304.747L315.562 293.909Z",
    fill: "#73007D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M340.821 293.909L322.133 283.157V304.747L340.821 293.909Z",
    fill: "#73007D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.149 11.5414L133.461 0.704102V22.2934L152.149 11.5414Z",
    fill: "#73007D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M177.408 11.5414L158.72 0.704102V22.2934L177.408 11.5414Z",
    fill: "#73007D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M224.597 61.7178H240.554",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M232.618 69.739V53.6963",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M503.552 179.478H525.994",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M514.73 190.741V168.299",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1309 253.206H65.2802",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1631 265.323V241.173",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M114.858 40.5547H185.002",
    stroke: "#D6AAD9",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M205.056 294.592H275.2",
    stroke: "#D6AAD9",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48535 71.6162H130.731",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0771 140.992H132.096",
    stroke: "#FFD15B",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8135 131.69H111.872",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M434.176 195.264H465.408",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M412.501 164.629L445.354 88.7679C445.354 88.4265 445.354 88.2559 445.354 88.2559H145.664L112.64 164.629H412.501Z",
    fill: "#FFD15B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M427.349 205.248C425.045 203.371 423.083 201.152 421.717 198.507C420.437 195.947 419.755 193.131 419.584 190.315C419.328 185.877 420.096 181.44 421.461 177.088H141.568L108.544 266.688H404.992L429.397 206.699C428.715 206.272 428.032 205.76 427.349 205.248Z",
    fill: "#D6AAD9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M90.709 110.442H149.248",
    stroke: "#FFD15B",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M428.459 93.888C428.459 93.5466 428.459 93.376 428.459 93.376H128.768L95.7441 169.749H128.768L95.7441 259.349H395.605L428.459 170.347C428.459 170.176 428.459 169.92 428.459 169.749",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M175.189 148.757C173.738 149.44 170.922 150.208 167.168 150.208C158.634 150.208 152.234 144.832 152.234 134.933C152.234 125.461 158.634 119.061 168.021 119.061C171.776 119.061 174.165 119.829 175.189 120.426L174.25 123.584C172.8 122.901 170.666 122.304 168.192 122.304C161.109 122.304 156.416 126.826 156.416 134.762C156.416 142.186 160.682 146.88 168.021 146.88C170.41 146.88 172.8 146.368 174.421 145.6L175.189 148.757Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M207.189 134.336C207.189 144.746 200.874 150.293 193.194 150.293C185.173 150.293 179.626 144.149 179.626 134.933C179.626 125.376 185.599 119.061 193.621 119.061C201.898 119.061 207.189 125.376 207.189 134.336ZM183.807 134.848C183.807 141.333 187.306 147.05 193.45 147.05C199.594 147.05 203.093 141.333 203.093 134.506C203.093 128.533 199.935 122.218 193.45 122.218C187.05 122.218 183.807 128.192 183.807 134.848Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M239.957 136.469C239.701 132.288 239.445 127.168 239.53 123.413H239.36C238.336 126.997 237.056 130.752 235.52 134.848L230.144 149.525H227.157L222.293 135.104C220.842 130.837 219.648 126.912 218.794 123.328H218.88C218.794 127.082 218.538 132.117 218.282 136.725L217.514 149.696H213.76L215.893 119.488H220.842L225.962 134.08C227.242 137.834 228.266 141.077 229.034 144.234H229.205C229.973 141.162 231.082 137.834 232.362 134.08L237.738 119.488H242.688L244.565 149.696H240.725L239.957 136.469Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M256.682 119.573V149.781H252.757V119.573H256.682Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M265.813 149.781V119.573H270.08L279.723 134.848C281.941 138.432 283.733 141.589 285.184 144.661L285.269 144.576C284.928 140.565 284.843 136.896 284.843 132.117V119.573H288.512V149.781H284.587L275.029 134.421C272.896 131.093 270.933 127.595 269.397 124.352L269.227 124.437C269.483 128.277 269.568 131.861 269.568 136.896V149.781H265.813Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M320.511 148.416C318.805 149.013 315.306 150.037 311.21 150.037C306.602 150.037 302.847 148.842 299.946 146.026C297.386 143.552 295.765 139.456 295.765 134.762C295.85 125.717 301.994 119.146 312.149 119.146C315.647 119.146 318.378 119.914 319.658 120.512L318.719 123.669C317.098 122.986 315.05 122.389 312.063 122.389C304.725 122.389 299.946 126.997 299.946 134.506C299.946 142.186 304.554 146.709 311.637 146.709C314.197 146.709 315.903 146.368 316.842 145.941V136.896H310.698V133.738H320.682V148.416H320.511Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M170.922 148.757C169.472 149.44 166.656 150.208 162.901 150.208C154.368 150.208 147.968 144.832 147.968 134.933C147.968 125.461 154.368 119.061 163.754 119.061C167.509 119.061 169.898 119.829 170.922 120.426L169.984 123.584C168.533 122.901 166.4 122.304 163.925 122.304C156.842 122.304 152.149 126.826 152.149 134.762C152.149 142.186 156.416 146.88 163.754 146.88C166.144 146.88 168.533 146.368 170.154 145.6L170.922 148.757Z",
    fill: "#73007D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M202.922 134.336C202.922 144.746 196.607 150.293 188.927 150.293C180.906 150.293 175.359 144.149 175.359 134.933C175.359 125.376 181.333 119.061 189.354 119.061C197.631 119.061 202.922 125.376 202.922 134.336ZM179.541 134.848C179.541 141.333 183.039 147.05 189.183 147.05C195.327 147.05 198.826 141.333 198.826 134.506C198.826 128.533 195.669 122.218 189.183 122.218C182.783 122.218 179.541 128.192 179.541 134.848Z",
    fill: "#73007D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M235.691 136.469C235.435 132.288 235.179 127.168 235.264 123.413H235.093C234.069 126.997 232.789 130.752 231.253 134.848L225.877 149.525H222.891L218.026 135.104C216.576 130.837 215.381 126.912 214.528 123.328H214.613C214.528 127.082 214.272 132.117 214.016 136.725L213.248 149.696H209.493L211.626 119.488H216.576L221.696 134.08C222.976 137.834 224 141.077 224.768 144.234H224.939C225.707 141.162 226.816 137.834 228.096 134.08L233.472 119.488H238.421L240.299 149.696H236.459L235.691 136.469Z",
    fill: "#73007D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M252.416 119.573V149.781H248.49V119.573H252.416Z",
    fill: "#73007D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M261.547 149.781V119.573H265.814L275.456 134.848C277.675 138.432 279.467 141.589 280.918 144.661L281.003 144.576C280.662 140.565 280.576 136.896 280.576 132.117V119.573H284.246V149.781H280.32L270.763 134.421C268.63 131.093 266.667 127.595 265.131 124.352L264.96 124.437C265.216 128.277 265.302 131.861 265.302 136.896V149.781H261.547Z",
    fill: "#73007D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M316.245 148.416C314.538 149.013 311.039 150.037 306.943 150.037C302.335 150.037 298.581 148.842 295.679 146.026C293.119 143.552 291.498 139.456 291.498 134.762C291.583 125.717 297.727 119.146 307.882 119.146C311.381 119.146 314.111 119.914 315.391 120.512L314.453 123.669C312.831 122.986 310.783 122.389 307.797 122.389C300.458 122.389 295.679 126.997 295.679 134.506C295.679 142.186 300.287 146.709 307.37 146.709C309.93 146.709 311.637 146.368 312.575 145.941V136.896H306.431V133.738H316.415V148.416H316.245Z",
    fill: "#73007D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M150.443 232.469C152.662 233.835 155.99 235.029 159.403 235.029C164.523 235.029 167.51 232.299 167.51 228.373C167.51 224.704 165.462 222.656 160.171 220.693C153.856 218.475 149.931 215.147 149.931 209.685C149.931 203.627 154.966 199.104 162.475 199.104C166.486 199.104 169.302 200.043 171.094 200.981L169.728 205.077C168.448 204.395 165.888 203.2 162.39 203.2C157.099 203.2 155.051 206.357 155.051 209.003C155.051 212.672 157.44 214.379 162.731 216.512C169.302 219.072 172.63 222.229 172.63 227.947C172.63 233.92 168.192 239.125 159.062 239.125C155.307 239.125 151.211 238.016 149.163 236.651L150.443 232.469Z",
    fill: "#73007D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M212.651 218.731C212.651 232.128 204.544 239.211 194.646 239.211C184.406 239.211 177.152 231.275 177.152 219.499C177.152 207.211 184.832 199.104 195.158 199.104C205.824 199.104 212.651 207.211 212.651 218.731ZM182.528 219.413C182.528 227.691 187.051 235.115 194.902 235.115C202.838 235.115 207.36 227.776 207.36 218.987C207.36 211.307 203.35 203.2 194.987 203.2C186.71 203.2 182.528 210.88 182.528 219.413Z",
    fill: "#73007D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M252.331 218.731C252.331 232.128 244.224 239.211 234.325 239.211C224.085 239.211 216.832 231.275 216.832 219.499C216.832 207.211 224.512 199.104 234.837 199.104C245.504 199.104 252.331 207.211 252.331 218.731ZM222.208 219.413C222.208 227.691 226.731 235.115 234.581 235.115C242.517 235.115 247.04 227.776 247.04 218.987C247.04 211.307 243.029 203.2 234.667 203.2C226.389 203.2 222.208 210.88 222.208 219.413Z",
    fill: "#73007D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M258.901 238.528V199.701H264.363L276.821 219.328C279.723 223.851 281.941 227.947 283.819 231.957L283.904 231.872C283.477 226.667 283.307 221.973 283.307 215.915V199.701H288V238.528H282.965L270.677 218.816C267.947 214.464 265.387 210.027 263.424 205.845L263.253 205.931C263.509 210.795 263.68 215.488 263.68 221.973V238.528H258.901Z",
    fill: "#73007D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M144.469 232.469C146.688 233.835 150.016 235.029 153.429 235.029C158.549 235.029 161.536 232.299 161.536 228.373C161.536 224.704 159.488 222.656 154.197 220.693C147.883 218.475 143.957 215.147 143.957 209.685C143.957 203.627 148.992 199.104 156.501 199.104C160.512 199.104 163.328 200.043 165.12 200.981L163.755 205.077C162.475 204.395 159.915 203.2 156.416 203.2C151.125 203.2 149.077 206.357 149.077 209.003C149.077 212.672 151.467 214.379 156.757 216.512C163.328 219.072 166.656 222.229 166.656 227.947C166.656 233.92 162.219 239.125 153.088 239.125C149.333 239.125 145.237 238.016 143.189 236.651L144.469 232.469Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M206.677 218.731C206.677 232.128 198.571 239.211 188.672 239.211C178.432 239.211 171.179 231.275 171.179 219.499C171.179 207.211 178.859 199.104 189.184 199.104C199.851 199.104 206.677 207.211 206.677 218.731ZM176.555 219.413C176.555 227.691 181.077 235.115 188.928 235.115C196.864 235.115 201.387 227.776 201.387 218.987C201.387 211.307 197.376 203.2 189.013 203.2C180.736 203.2 176.555 210.88 176.555 219.413Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M246.357 218.731C246.357 232.128 238.25 239.211 228.352 239.211C218.112 239.211 210.858 231.275 210.858 219.499C210.858 207.211 218.538 199.104 228.864 199.104C239.53 199.104 246.357 207.211 246.357 218.731ZM216.234 219.413C216.234 227.691 220.757 235.115 228.608 235.115C236.544 235.115 241.066 227.776 241.066 218.987C241.066 211.307 237.056 203.2 228.693 203.2C220.416 203.2 216.234 210.88 216.234 219.413Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M252.928 238.528V199.701H258.389L270.848 219.328C273.749 223.851 275.968 227.947 277.845 231.957L277.93 231.872C277.504 226.667 277.333 221.973 277.333 215.915V199.701H282.026V238.528H276.992L264.704 218.816C261.973 214.464 259.413 210.027 257.45 205.845L257.28 205.931C257.536 210.795 257.706 215.488 257.706 221.973V238.528H252.928Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M431.786 219.243H493.909",
    stroke: "#D6AAD9",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M427.008 244.672H545.962",
    stroke: "#D6AAD9",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M298.752 77.5039H361.813",
    stroke: "#FFD15B",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M445.44 274.368C445.44 274.368 459.349 246.208 454.144 222.315C450.048 203.371 422.314 192.704 423.85 182.549C425.557 171.456 459.349 167.616 467.541 153.451C474.538 141.248 474.538 106.603 474.538 106.603L393.898 93.4614C393.898 93.4614 382.805 126.315 385.621 140.139C388.864 156.181 419.669 170.603 417.792 181.611C416 191.765 386.304 193.045 376.405 209.685C363.946 230.677 368.128 261.824 368.128 261.824L445.44 274.368Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M434.176 108.224C434.176 108.224 455.424 122.304 462.336 147.648C470.101 134.251 467.626 113.685 467.626 113.685L434.176 108.224Z",
    fill: "#FFD15B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M451.328 275.222L424.448 270.87L389.12 265.067L362.24 260.715C355.669 259.606 349.525 264.128 348.416 270.614L347.562 275.734L386.304 282.048L421.632 287.851L460.373 294.166L461.227 289.046C462.336 282.39 457.899 276.246 451.328 275.222Z",
    fill: "#FFF6D9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M459.776 90.9015L424.448 85.0989L385.706 78.7842L384.853 83.9042C383.744 90.4748 388.266 96.6188 394.752 97.7282L421.632 102.08L456.96 107.883L483.84 112.235C490.41 113.344 496.554 108.822 497.664 102.336L498.517 97.2162L459.776 90.9015Z",
    fill: "#D6AAD9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M456.448 280.256L429.568 275.904L394.24 270.102L367.36 265.75C360.789 264.64 354.645 269.163 353.536 275.648L352.683 280.768L391.424 287.083L426.752 292.886L465.493 299.2L466.347 294.08C467.456 287.51 463.019 281.366 456.448 280.256Z",
    fill: "#D6AAD9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M454.656 85.7814L419.328 79.9787L380.586 73.6641L379.733 78.7841C378.624 85.3547 383.146 91.4987 389.632 92.6081L416.512 96.9601L451.84 102.763L478.72 107.115C485.29 108.224 491.434 103.701 492.544 97.2161L493.397 92.0961L454.656 85.7814Z",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M451.328 275.222L424.448 270.87L389.12 265.067L362.24 260.715C355.669 259.606 349.525 264.128 348.416 270.614L347.562 275.734L386.304 282.048L421.632 287.851L460.373 294.166L461.227 289.046C462.336 282.39 457.899 276.246 451.328 275.222Z",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M393.898 93.376C393.898 93.376 382.805 126.229 385.621 140.053C388.864 156.096 419.669 170.517 417.792 181.525C416 191.68 386.304 192.96 376.405 209.6C363.946 230.592 368.128 261.739 368.128 261.739",
    stroke: "#73007D",
    strokeWidth: 3.3,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M474.538 106.517C474.538 106.517 474.624 141.248 467.541 153.365C459.349 167.53 425.557 171.456 423.851 182.464C422.315 192.618 450.048 203.285 454.144 222.229C459.264 246.122 445.44 274.282 445.44 274.282",
    stroke: "#73007D",
    strokeWidth: 3.3,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M392.277 138.773C391.85 139.029 391.68 139.541 391.936 139.883C393.301 142.016 397.482 148.331 403.285 154.475C409.941 161.557 418.474 168.128 423.168 168.896C435.882 170.944 461.397 151.915 461.824 150.379C444.501 155.413 438.528 153.621 422.57 139.371C411.648 129.643 395.861 136.896 392.277 138.773Z",
    fill: "#73007D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M441.685 269.504C440.576 258.325 435.37 225.045 414.549 221.632C393.898 218.304 378.282 247.829 373.333 258.325L441.685 269.504Z",
    fill: "#73007D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M428.971 216.598C428.63 218.816 426.496 220.352 424.192 220.011C421.974 219.67 420.438 217.536 420.779 215.232C421.12 213.014 423.254 211.478 425.558 211.819C427.776 212.246 429.312 214.379 428.971 216.598Z",
    fill: "#73007D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M412.757 207.125C412.501 208.832 410.88 210.027 409.173 209.685C407.466 209.429 406.272 207.808 406.613 206.101C406.869 204.395 408.49 203.2 410.197 203.541C411.818 203.712 413.013 205.333 412.757 207.125Z",
    fill: "#73007D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M422.826 195.776C422.57 197.141 421.29 198.08 420.01 197.824C418.645 197.568 417.706 196.288 417.962 195.008C418.218 193.643 419.498 192.704 420.778 192.96C422.058 193.131 422.997 194.411 422.826 195.776Z",
    fill: "#73007D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M431.274 202.688C431.274 202.688 444.501 208.917 448.597 223.424C452.01 235.541 448.938 244.416 448.938 244.416C448.938 244.416 445.184 228.885 443.306 224.107C438.442 211.477 431.274 202.688 431.274 202.688Z",
    fill: "#FFD15B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30371 305.259H88.3197",
    stroke: "#FFD15B",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M372.053 342.379H532.65",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M129.536 292.373C129.365 294.336 127.573 295.701 125.61 295.531C123.648 295.36 122.282 293.568 122.453 291.605C122.624 289.643 124.416 288.277 126.378 288.448C128.341 288.704 129.792 290.411 129.536 292.373Z",
    fill: "white",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4843 15.7109C89.458 15.56 90.9356 13.8377 90.7847 11.864C90.6338 9.8904 88.9115 8.41278 86.9379 8.56368C84.9642 8.71458 83.4866 10.4369 83.6375 12.4105C83.7884 14.3842 85.5107 15.8618 87.4843 15.7109Z",
    fill: "white",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M530.678 305.025C532.624 304.663 533.909 302.793 533.547 300.847C533.185 298.9 531.315 297.616 529.368 297.978C527.422 298.339 526.138 300.21 526.5 302.156C526.861 304.102 528.732 305.387 530.678 305.025Z",
    fill: "white",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M439.723 36.9707C439.723 38.9334 438.101 40.5547 436.139 40.5547C434.176 40.5547 432.555 38.9334 432.555 36.9707C432.555 35.008 434.176 33.3867 436.139 33.3867C438.101 33.3867 439.723 35.008 439.723 36.9707Z",
    fill: "white",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M147.541 335.467C147.285 338.283 144.725 340.331 141.909 339.989C139.093 339.733 137.045 337.173 137.387 334.357C137.643 331.541 140.203 329.493 143.019 329.835C145.835 330.176 147.883 332.651 147.541 335.467Z",
    fill: "white",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1574 200.64C99.1574 203.2 97.1094 205.248 94.5494 205.248C91.9894 205.248 89.9414 203.2 89.9414 200.64C89.9414 198.08 91.9894 196.032 94.5494 196.032C97.1094 196.032 99.1574 198.08 99.1574 200.64Z",
    fill: "#FFD15B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M506.027 275.733C508.901 275.733 511.232 273.403 511.232 270.528C511.232 267.653 508.901 265.323 506.027 265.323C503.152 265.323 500.821 267.653 500.821 270.528C500.821 273.403 503.152 275.733 506.027 275.733Z",
    fill: "#D6AAD9"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M403.795 52.7614C404.636 49.1832 402.418 45.6 398.84 44.7582C395.262 43.9164 391.679 46.1347 390.837 49.7129C389.995 53.2912 392.213 56.8743 395.791 57.7161C399.37 58.5579 402.953 56.3396 403.795 52.7614Z",
    fill: "white",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8294 327.787C95.5734 330.262 93.3547 331.968 90.9654 331.712C88.4907 331.456 86.784 329.238 87.04 326.848C87.296 324.374 89.5147 322.667 91.904 322.923C94.2934 323.179 96.0854 325.312 95.8294 327.787Z",
    fill: "white",
    stroke: "#73007D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7165 99.3327L67.5273 94.1436L62.3382 99.3327L67.5273 104.522L72.7165 99.3327Z",
    fill: "#D6AAD9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6819 191.686L23.0615 188.065L19.4412 191.686L23.0615 195.306L26.6819 191.686Z",
    fill: "#D6AAD9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M179.411 314.279L175.791 310.659L172.171 314.279L175.791 317.899L179.411 314.279Z",
    fill: "#FFD15B"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M546.777 142.884L543.156 139.264L539.536 142.884L543.156 146.504L546.777 142.884Z",
    fill: "#D6AAD9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M491.049 313.986L485.859 308.797L480.67 313.986L485.859 319.175L491.049 313.986Z",
    fill: "#FFD15B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M450.556 65.989L445.367 60.7998L440.178 65.989L445.367 71.1782L450.556 65.989Z",
    fill: "#FFD15B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDahboardComingSoon);
export default __webpack_public_path__ + "static/media/Dahboard_coming_soon.be9e2da16239f311ac0b604d74ab7088.svg";
export { ForwardRef as ReactComponent };